export const usersListConstants = {
    USERS_LIST_REQUEST: 'USERS_LIST_REQUEST',
    USERS_LIST_SUCCESS: 'USERS_LIST_SUCCESS',
    USERS_LIST_FAILURE: 'USERS_LIST_FAILURE',
    /* Export Data Constants */
    EXPORT_USERS_REQUEST: 'EXPORT_USERS_REQUEST',
    EXPORT_USERS_SUCCESS: 'EXPORT_USERS_SUCCESS',
    EXPORT_USERS_FAILURE: 'EXPORT_USERS_FAILURE',
    EXPORT_USERS_STATUS: 'EXPORT_USERS_STATUS',
}